import styles from './Content.module.scss';

interface Props {
   children: React.ReactNode;
}

export default function Content({ children }: Props) {
   return <div className={styles.content}>{children}</div>;
}
